import React from 'react'
import { NavLink } from 'react-router-dom'
import './style.scss'

const MyBiyesadi = () => {
    return (
        <div className="custom-navbar">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <NavLink
                            to="/my-biyesadi/"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >Dashboard</NavLink>
                        <NavLink
                            to="/my-biyesadi/profile"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >profile</NavLink>
                        <NavLink
                            to="/my-biyesadi/photos"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >photo</NavLink>
                        <NavLink
                            to="/my-biyesadi/partner-preference"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >partner preference</NavLink>
                        <NavLink
                            to="/my-biyesadi/settings"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >settings</NavLink>
                        <NavLink
                            to="/my-biyesadi/contact"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >contact details</NavLink>
                        <NavLink
                            to="/my-biyesadi/package"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >packages</NavLink>
                        <NavLink
                            to="/my-biyesadi/paymentlog"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >payment log</NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyBiyesadi;